import axios from '../../config/axios.js'
import { addIso690 } from '../../custom/function.js'

const STATE = {

    document_notes: null,
    doc_note_info: {},
    proj_note_info: {},
    changed_doc_key: null,

}

const GETTERS = {

    document_notes: state => state.document_notes,
    doc_note_info: state => state.doc_note_info,
    proj_note_info: state => state.proj_note_info,
    changed_doc_key: state => state.changed_doc_key,

}

const MUTATIONS = {

    getDocumentNotes(state, result) {
        state.document_notes = result
    },

    getDocNoteInfo(state, note) {
        state.doc_note_info = note
    },

    resetDocNoteInfo(state) {
        state.doc_note_info = {}
    },

    getProjNoteInfo(state, note) {
        state.proj_note_info = note
    },

    resetProjNoteInfo(state) {
        state.proj_note_info = {}
    },

    setChangedDocKey(state, doc_key) {
        state.changed_doc_key = doc_key
    },

}

const ACTIONS = {

    async getDocumentNotes({ commit }, payload) {
        await axios.ACCESS.get('/api/documentnotes')
            .then(res => {
                // console.log('notes/getDocumentNotes', res)
                addIso690(res.data.document_notes)
                    .then(res => {
                        commit('getDocumentNotes', res)
                    })
            })
    },

    async getDocNoteInfo({ commit }, doc_key) {
        await axios.ACCESS.get('/api/document/' + doc_key + '/note')
            .then(res => {
                // console.log('/notes/getDocNoteInfo', res)
                if (res.data.result) {
                    commit('getDocNoteInfo', res.data.note)
                } else { throw new Error(res.data) }
            })
    },

    async saveDocNoteDraft({ commit }, payload) {
        await axios.ACCESS.post('/api/docnotedraft/' + payload.note_id + '/draft', {
                draft: payload.draft,
            })
            .then(res => {
                // console.log('/notes/saveDocNoteDraft', res)
                if (!res.data.result) { throw new Error(res.data) }
            })
    },

    async cancelDocNoteDraft({ commit }, note_id) {
        await axios.ACCESS.post('/api/docnotedraft/' + note_id + '/cancel')
            .then(res => {
                // console.log('/notes/cancelDocNoteDraft', res)
                if (!res.data.result) { throw new Error(res.data) }
            })
    },

    async saveDocNote({ commit }, payload) {
        await axios.ACCESS.post('/api/docnotedraft/' + payload.note_id + '/save', {
                note: payload.note,
            })
            .then(res => {
                // console.log('/notes/saveDocNote', res)
                commit('setChangedDocKey', payload.doc_key)
                if (!res.data.result) { throw new Error(res.data) }
            })
    },

    async getProjNoteInfo({ commit }, proj_id) {
        await axios.ACCESS.get('/api/project/' + proj_id + '/note')
            .then(res => {
                // console.log('/notes/getProjNoteInfo', res)
                if (res.data.result) {
                    commit('getProjNoteInfo', res.data.note)
                } else { throw new Error(res.data) }
            })
    },

    async saveProjNoteDraft({ commit, dispatch }, payload) {
        await axios.ACCESS.post('/api/projnotedraft/' + payload.proj_id + '/draft', {
                draft: payload.draft,
            })
            .then(res => {
                // console.log('/notes/saveProjNoteDraft', res)
                if (!res.data.result) { throw new Error(res.data) }
            })
    },

    async saveProjNote({ commit }, payload) {
        await axios.ACCESS.post('/api/projnotedraft/' + payload.proj_id + '/save', {
                note: payload.note,
                note_wc: payload.note_wc
            })
            .then(res => {
                // console.log('/notes/saveProjNote', res)
                if (!res.data.result) { throw new Error(res.data) }
            })
    },

    async cancelProjNoteDraft({ commit }, proj_id) {
        await axios.ACCESS.post('/api/projnotedraft/' + proj_id + '/cancel')
            .then(res => {
                // console.log('/notes/cancelProjNoteDraft', res)
                if (!res.data.result) { throw new Error(res.data) }
            })
    },

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/notes.js